import {
  CREATING_TESTIMONIAL,
  UPDATING_TESTIMONIAL,
  TESTIMONIAL_CREATED,
  TESTIMONIAL_UPDATED,
  ERROR_TESTIMONIAL_CREATE,
  UPDATED_RECENTLY,
  SET_UPDATED_RECENTLY_TO_FALSE,
  ERROR_TESTIMONIAL_UPDATE
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const setUpdatedRecentlyToFalse = () => async (dispatch) => {
  dispatch({
    type: SET_UPDATED_RECENTLY_TO_FALSE,
  });
};
export const createEntity =
  (formData, tokenData, exitNow, history) => async (dispatch) => {
    dispatch({
      type: CREATING_TESTIMONIAL,
    });
    let data = Object.fromEntries(
      Object.entries(formData)
        .filter(([_, v]) => v != null)
        .filter(([_, v]) => v !== "")
        .filter(([_, v]) => v !== undefined)
    );   

    let webKitFormData = new FormData();
    if (data.package_id) {
      for (let i = 0; i < data.package_id.length; i++) {
        webKitFormData.append("package_id[]", data.package_id[i]);
      }
    } ["package_id"].forEach(
      (e) => delete data[e]
    );

    Object.keys(data).forEach((item, i) => {
      webKitFormData.append(item, data[item]);
    });

    await axios
      .post(`${BASE_URL}api/v1/admin/testimonial/add`, webKitFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
        },
      })
      .then(function (response) {
        dispatch({
          type: TESTIMONIAL_CREATED,
          payload: response,
        });
        dispatch({
          type: UPDATED_RECENTLY,
        });
        if (exitNow) {
          history.push("/testimonials");
          message.success(response.data.message);
        }
      })
      .catch(function (error) {
        dispatch({
          type: ERROR_TESTIMONIAL_CREATE,
          payload: error.response,
        });
        message.error(error.response.data.message);
      });
  };

export const updateEntityInfo =
  (formData, tokenData, id) => async (dispatch) => {
    dispatch({
      type: UPDATING_TESTIMONIAL,
    });

    let data = Object.fromEntries(
      Object.entries(formData)
        .filter(([_, v]) => v != null)
        .filter(([_, v]) => v !== "")
        .filter(([_, v]) => v !== undefined)
    );

    let webKitFormData = new FormData();
    if (data.package_id) {
      for (let i = 0; i < data.package_id.length; i++) {
        webKitFormData.append("package_id[]", data.package_id[i]);
      }
    } 
    ["package_id"].forEach(
      (e) => delete data[e]
    );
    Object.keys(data).forEach((item, i) => {
      webKitFormData.append(item, data[item]);
    });
    webKitFormData.append("_method", "put");

    await axios
      .post(`${BASE_URL}api/v1/admin/testimonial/edit/${id}`, webKitFormData, {
        headers: {
          Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
        },
      })
      .then(function (response) {
        dispatch({
          type: TESTIMONIAL_UPDATED,
          payload: response,
        });
        dispatch({
          type: UPDATED_RECENTLY,
        });
        message.success(response.data.message);
      })
      .catch(function (error) {
        dispatch({
          type: ERROR_TESTIMONIAL_UPDATE,
          payload: error.response,
        });
        message.error(error.response.data.message);
      });
  };

